export function since(timestamp) {
    const now = new Date();
    const diff = now.getTime() - timestamp.getTime();
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (seconds < 60)
        return {
            en: `${seconds} seconds ago`,
            cs: `před ${seconds} sekundami`,
        };
    if (minutes < 60)
        return { en: `${minutes} minutes ago`, cs: `před ${minutes} minutami` };
    if (hours < 24)
        return { en: `${hours} hours ago`, cs: `před ${hours} hodinami` };
    if (days < 7)
        return { en: `${days} days ago`, cs: `před ${days} dny` };
    return 'since ' + timestamp;
}
